import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { MdSpaceDashboard } from "react-icons/md";
import { BsFillPeopleFill } from "react-icons/bs";
import { FaCalendarAlt } from "react-icons/fa";

import Dashboards from "./itens/Dashboards";
import Alunas from './itens/Alunas';
import Cronograma from './itens/Cronograma';
import AdminHamburguer from './components/AdminHamburguer';

import './adminPanel.css';
import './adminGlobal.css';
 
const AdminPanel = () => {
  const navigate = useNavigate();
  const [dateTime, setDateTime] = useState(new Date());
  const [selectedComponent, setSelectedComponent] = useState(<Dashboards />); // Define o componente inicial
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [menuOpen, setMenuOpen] = useState(false);

  // Componentes disponíveis para o menu hamburguer
  const availableComponents = {
    dashboards: <Dashboards />,
    alunas: <Alunas />,
    cronograma: <Cronograma />
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
      if (window.innerWidth > 992) {
        // Fechar o menu hamburguer quando a tela for redimensionada para desktop
        const menuBg = document.getElementById("admin-menu-bg");
        const menuBar = document.getElementById("admin-menu-bar");
        const nav = document.getElementById("admin-nav");
        
        if (menuBg && menuBar && nav) {
          menuBg.classList.remove("change-bg");
          menuBar.classList.remove("change");
          nav.classList.remove("change");
        }
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("isAdminAuthenticated");
    navigate("/admin");
    window.location.reload();
  };

  return (
    <section className="adminPainel">
      {/* Menu lateral para desktop */}
      <div className={`menuLateral ${isMobile ? 'hidden' : ''}`}>
        <h2>Admin Panel</h2>
        <div className='h5menus'>
          <h5 onClick={() => setSelectedComponent(<Dashboards />)}>
            <MdSpaceDashboard /> Dashboards
          </h5>

          <h5 onClick={() => setSelectedComponent(<Alunas />)}>
            <BsFillPeopleFill /> Alunas
          </h5>

          <h5 onClick={() => setSelectedComponent(<Cronograma />)}>
            <FaCalendarAlt /> Cronograma
          </h5>
        </div>
      </div>

      {/* Menu hamburguer para mobile */}
      {isMobile && (
        <AdminHamburguer 
          setSelectedComponent={setSelectedComponent} 
          handleLogout={handleLogout}
          components={availableComponents}
        />
      )}

      <div className={`painelContent ${isMobile ? 'full-width' : ''}`}>
        <div className="headerADM">
          <h4 className="welcome-text">Bem Vindo, Administrador</h4>
          <h4 className="datetime">{dateTime.toLocaleString()}</h4>
          {!isMobile && (
            <button 
              onClick={handleLogout} 
              className="logout-btn"
              aria-label="Sair do sistema"
            >
              Sair
            </button>
          )}
        </div>

        <div className='componentesShow'>
          {selectedComponent} {/* Renderiza o componente selecionado */}
        </div>
      </div>
    </section>
  );
};

export default AdminPanel;
